import React from 'react';
import { ItemSection, ItemData } from './ItemSection';
const data: ItemData = {
  number: 5,
  title: "Your Toddler's Skin Barrier Isn't Fully Developed (Making Them 3-5x More Vulnerable Than You Are)",
  mechanism: <>
      Young children's skin has a <strong data-id="element-158">thinner outer layer</strong> (stratum
      corneum) and an <strong data-id="element-159">underdeveloped acid mantle</strong> compared to
      adult skin. This means the same chlorine concentration and hard water
      minerals that might cause minor irritation in adults cause{' '}
      <strong data-id="element-160">significant flare-ups</strong> in toddlers. Additionally,
      children's skin hasn't yet developed the full microbiome diversity of
      adult skin—fewer protective bacteria means{' '}
      <strong data-id="element-161">less natural defense</strong> against chemical disruption.
    </>,
  avatars: {
    jessica: <>
        Your toddler's skin is <strong data-id="element-162">more visually reactive</strong> to the
        same water exposure you experience without noticing. The difference
        isn't subjective—it's <strong data-id="element-163">structural</strong>.
      </>,
    michelle: <>
        This is why a one-size-fits-all health approach <strong data-id="element-164">fails</strong>{' '}
        for families with young children. Their physiological needs are{' '}
        <strong data-id="element-165">fundamentally different</strong>.
      </>
  },
  bridge: <>
      Creams can soothe irritation, but they <strong data-id="element-166">can't compensate</strong>{' '}
      for developmental skin barrier immaturity against{' '}
      <strong data-id="element-167">chemical exposure</strong>.
    </>,
  image: {
    url: 'https://images.unsplash.com/photo-1576086213369-97a306d36557?w=800&q=80',
    alt: 'Side-by-side anatomical diagram comparing thin toddler skin structure with thicker adult skin structure, highlighting underdeveloped barrier in children'
  },
  imageOnLeft: false
};
export function Item5Section() {
  return <ItemSection data={data} data-id="element-168" />;
}